import {PlayerModal, RegisterForm, RegisterFormProps} from "src/components";

export function PlayerNoLoginWindow({onRegistered}: {onRegistered: RegisterFormProps['onRegistered']}) {
    return (<PlayerModal>
        <RegisterForm title={'Live Kijken'} onRegistered={onRegistered} />
    </PlayerModal>)
}